"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppSectionNavigation = exports.AppSectionNavigationDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var current_path_name_1 = require("../../utils/current-path-name");
var lodash_1 = require("lodash");
var secondary_navigation_1 = require("../elements/secondary-navigation");
var app_section_navigation_item_1 = require("../../utils/app-section-navigation-item");
exports.AppSectionNavigationDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  "])))
});
var NavigationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n    padding-right: ", ";\n    padding-left: ", ";\n    margin-left: ", ";\n    ", ";\n  "], ["\n    flex-shrink: 0;\n    padding-right: ", ";\n    padding-left: ", ";\n    margin-left: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5), theme_1.theme.UNIT(5), theme_1.theme.DOT_BG('v', 'line-mid', 2, 4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Navigation: (0, styled_components_1.default)(secondary_navigation_1.SecondaryNavigation)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), NavigationStyles),
  Controls: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
var AppSectionNavigation = function (props) {
  var className = props.className,
    appSection = props.appSection,
    controls = props.controls;
  var entities = (0, use_entities_1.useEntities)();
  var icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  var currentPath = (0, current_path_name_1.currentPathName)();
  var items = (0, react_1.useMemo)(function () {
    var childItems = appSection.children.map(function (appSectionChild) {
      return (0, app_section_navigation_item_1.appSectionNavigationItem)({
        appSection: appSection,
        t: t,
        appSectionChild: appSectionChild,
        icons: icons,
        entities: entities
      });
    });
    // now find the current item by taking the longest item that starts with the current path
    var itemsOnCurrentPath = (0, lodash_1.sortBy)((0, lodash_1.filter)(childItems, function (item) {
      return (0, lodash_1.startsWith)(currentPath, item.to);
    }), function (item) {
      return item.to.length;
    });
    var currentItemIndex = itemsOnCurrentPath.length - 1;
    if (currentItemIndex >= 0) {
      itemsOnCurrentPath[currentItemIndex].isActive = true;
    }
    return childItems;
  }, [appSection]);
  return react_1.default.createElement(My.Container, null, react_1.default.createElement(My.Navigation, {
    items: items,
    className: className
  }), controls && react_1.default.createElement(My.Controls, null, controls));
};
exports.AppSectionNavigation = AppSectionNavigation;
exports.AppSectionNavigation.defaultProps = exports.AppSectionNavigationDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;